import React from 'react';
import { useTranslation } from 'react-i18next';

import { PageTitle } from './PageTitle.jsx';

import { AppContext } from '../AppContext';

const Statistics = () => {
	const { t } = useTranslation();
	const app = React.useContext(AppContext);
	const userdata = app.userdata;

	const categories = Object.entries({
		gamesPlayed: t('Matches Played'),
		win: t('Wins'),
		win_rate: t('Win Rate'),
		win_streak: t('Win Streak'),
		win_streak_max: t('Win Streak Max'),
		loss_streak: t('Loss Streak'),
		round_played: t('Rounds Played'),
		roundOpponent_played: t('Rounds Played (Opponent)'),
		round_win: t('Rounds Won'),
		roundOpponent_win: t('Rounds Won (Opponent)'),
		round_loss: t('Rounds Lost'),
		roundOpponent_loss: t('Rounds Lost (Opponent)'),
		round_points: t('Points'),
		roundOpponent_points: t('Points (Opponent)'),
		round_win_points_avg: t('Points Win Avg'),
		roundOpponent_win_points_avg: t('Points Win Avg (Opponent)'),
		round_deadwood: t('Deadwood'),
		roundOpponent_deadwood: t('Deadwood (Opponent)'),
		round_gin: t('Gin'),
		roundOpponent_gin: t('Gin (Opponent)'),
		round_bigGin: t('Big Gin'),
		roundOpponent_bigGin: t('Big Gin (Opponent)'),
		round_undercut: t('Undercut'),
		roundOpponent_undercut: t('Undercut (Opponent)'),
		round_points_avg: t('Points Avg'),
		roundOpponent_points_avg: t('Points Avg (Opponent)'),
		round_deadwood_avg: t('Deadwood Avg'),
		roundOpponent_deadwood_avg: t('Deadwood Avg (Opponent)'),
		round_gin_avg: t('Gin Avg'),
		roundOpponent_gin_avg: t('Gin Percent (Opponent)'),
		round_bigGin_avg: t('Big Gin Percent'),
		roundOpponent_bigGin_avg: t('Big Gin Percent (Opponent)'),
		round_undercut_avg: t('Undercut Percent'),
		roundOpponent_undercut_avg: t('Undercut Percent (Opponent)'),
		round_deadwood_max: t('Deadwood Max'),
		round_points_max: t('Points Max'),
		round_points_last: t('Points Last'),
	});

	const levels = [
		t('Easy'),
		t('Medium'),
		t('Hard'),
		t('CrazyNinja'),
	];

	//const levelsPossible = ["Easy", "Medium", "Hard", "CrazyNinja"];
	// //filter out levels not played
	// let levels = [];
	// for (let i = 0; i < levelsPossible.length; i++) {
	//     let level = levelsPossible[i];
	//     if (userdata["gamesPlayed_" + level]) levels.push(level);
	// }

	const headerRow = (
		<thead>
			<tr>
				<th key="Catagory">{t('Category')}</th>
				{levels.map((level) => (
					<th key={level} >{level}</th>
				))}
			</tr>
		</thead>
	);

	const itemRows = categories.map(([key, name]) => {
		return (
			<tr key={key}>
				<td >{name}</td>
				{levels.map((level) => {
					const statKey = key + '_' + level;
					const value = userdata[statKey] || 0;
					return (
						<td key={statKey} >{value}</td>
					);
				})
				}

			</tr>
		);

	});
	return (

		<div id="Stats1" className="page1 paddingTop50">
			<div className="xwrapper">
				<PageTitle>
					<h1>{t('Statistics')}</h1>
				</PageTitle>
				<table className='statsTable'>
					{headerRow}
					<tbody>
						{itemRows}
					</tbody>

				</table>
			</div>
		</div>
	);
};

export default React.memo(Statistics);
